<template>
  <div class="box">
    <div class="content-box">
      <div style="width: 100%;text-align: center;margin-top: 20px;font-size: 18px;color: #272929;font-weight: 600;;">用户登录</div>
      <div class="box-item" style="margin-top: 24px;">
        <div>
          <div
            style="
              font-size: 16px;
              color: #272929;
              font-weight: 600;
              position: relative;
              margin-left: 2px;
            "
          >
            <div>1 账号？</div>
            <!-- <div class="lines"></div> -->
          </div>
        </div>
        <div style="font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;margin-top: 10px;">
          <input
            type="text"
            class="input-gh"
            style="background: rgba(247, 247, 247, 1);padding-left: 23px;"
            placeholder="账号"
            v-model="staff_no"
          />
        </div>
      </div>
      <div class="box-item" style="margin-top: 24px;">
        <div>
          <div
            style="
              font-size: 16px;
              color: #272929;
              font-weight: 600;
              position: relative;
              margin-left: 2px;
            "
          >
            <div>2 密码？</div>
            <!-- <div class="lines"></div> -->
          </div>
        </div>
        <div style="font-size: 15px; font-weight: 500;width: 100%;height: 44px;background: rgba(247, 247, 247, 1);border-radius: 8px;border: 1px solid #F7F7F7;margin-top: 10px;">
          <input
            type="text"
            class="input-gh"
            style="background: rgba(247, 247, 247, 1);padding-left: 23px;"
            placeholder="密码"
            v-model="duties"
          />
        </div>
      </div>
      <div style="height: 30px"></div>
      <div class="share-url" @click="shareUrl">登录</div>
      <!-- <div class="share-url1" @click="shareBarCode">分享二维码图片</div> -->
      <!-- <div class="share-url1" @click="initData">getUserInfo</div> -->
      <!-- <div v-if="workNumber == '00870'" class="share-url1" @click="chatRecipient">getUserInfo</div> -->
    </div>
    <div class="loading" v-show="isLoading">
      <van-loading text-color="#4873C0" color="#4873C0" vertical
        >加载中...</van-loading
      >
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import { user } from "@/api";
import Bar from "@/components/temp/bar.vue";
import ListItem from "@/components/temp/list-item.vue";
import { Popup, Picker, Loading, Toast, Dialog, Empty, Overlay } from "vant";
import CONFIG from "../../config";
const wx = window.wx;
import { JSEncrypt } from "jsencrypt";
import Watermark from "@/utils/watermark.js";
import dayjs from 'dayjs'
export default {
  components: {
    Bar,
    ListItem,
    VanPopup: Popup,
    VanLoading: Loading,
    VanPicker: Picker,
    VanEmpty: Empty,
    VanOverlay: Overlay,
  },
  data() {
    return {
      staff_name: '',
      staff_no: 'admin01',
      staff_department: '',
      duties: '123456',
      mobile: '',
      isLoading: false
    };
  },
  filters: {
    formatDate(date) {
      return date.substring(0, 10);
    },
  },
  mounted() {
  },
  activated() {
    document.title = "登录";
  },
  methods: {
    shareUrl() {
      // Toast("开发中");
      if (this.staff_no == "") {
        Toast("请填写账号");
        return;
      }
      if (this.duties == "") {
        Toast("请填写密码");
        return;
      }
      this.isLoading = true;
      let params = {
        userNo: this.staff_no,
        password: this.duties,
      };
      console.log(params, "params")
      user.login(params).then(res => {
        if(res.data.code == 200) {
          localStorage.setItem('token', res.data.data)
          this.isLoading = false;
          Toast('登录成功');
          this.$router.replace({
              path:'/dashboard'
          })
        }
      })
    },
    generateRandomInteger(length) {
        let result = '';
        for (let i = 0; i < length; i++) {
            result += Math.floor(Math.random() * 10);
        }
        return parseInt(result, 10);
    }
  },
};
</script>
<style scoped>
/deep/ .van-empty__description {
  margin-top: 0 !important;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.wrapper-box {
  width: 95%;
  /* height: 291px; */
  background: #fff;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
}
.lc-content-box {
  display: flex;
  width: 90%;
  margin-left: 5%;
  justify-content: space-around;
  margin-top: 15px;
}
.lc-title {
  margin-top: 27px;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  text-align: center;
}
.lc-content-one-box {
  width: 41%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.bzxq {
  display: flex;
  align-items: center;
  margin-top: 6px;
  color: #272929;
  font-weight: 600;
  white-space: nowrap;
}
.knows {
  margin-top: 21px;
  width: 66%;
  height: 44px;
  line-height: 44px;
  margin-left: 17%;
  border-radius: 5px;
  background: #2a7bc2;
  /* padding: 10px 0; */
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
}
.knows1 {
  margin-top: 10px;
  width: 66%;
  margin-left: 17%;
  border-radius: 5px;
  height: 44px;
  line-height: 44px;
  border: 1px solid #2a7bc2;
  /* padding: 10px 0; */
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #2a7bc2;
  cursor: pointer;
  margin-bottom: 30px;
}
.line-lc {
  width: 27%;
  height: 1px;
  background: #dcdfed;
  margin-top: 19px;
}
.xiaoqiaotixing-box {
  display: flex;
  align-items: center;
}
.xiaoqiaotixing-box div {
  background: rgba(42, 123, 194, 0.06);
  padding: 9px 8px 9px 12px;
  color: #2a7bc2;
  font-size: 13px;
  font-weight: 500;
  border-radius: 14px 14px 14px 0px;
  margin-left: 5px;
}
.lines {
  width: 34px;
  height: 4px;
  background: #2a7bc2;
  border-radius: 3px;
  opacity: 0.22;
  position: absolute;
  left: -7px;
  top: 16px;
}
.box-item2 {
  /* height: 121px; */
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 1px solid #f2f2f2; */
}
.input-xq {
  width: 100%;
  border: none;
  margin-top: 8px;
  height: 86px;
  font-size: 15px;
  resize: none;
  font-weight: 500;
}

textarea::placeholder {
  color: #c0c0c0;
  font-size: 15px;
}
.user-type1 {
  width: 48%;
  display: flex;
  align-items: center;
  text-align: center;
  line-height: 44px;
  cursor: pointer;
  /* margin-right: 15px; */
  margin-top: 14px;
  border-radius: 8px;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  text-align: center;
  font-style: normal;
}
.yjzrgx {
  /* margin-top: 8px; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.chd-icon {
  width: 58px;
  height: 58px;
  position: absolute;
  right: 10px;
  bottom: 140px;
}
.lqcg-title {
  width: 100%;
  text-align: center;
  padding-top: 15px;
  color: #4b4c4d;
  font-size: 16px;
  /* margin-left: 15px; */
}
.dio-box {
  width: 280px;
  min-height: 120px;
  border-radius: 10px;
  position: relative;
  background: #fff;
}
.input-box2 {
  padding: 20px;
}
.bot-btn {
  width: 100%;
  /* margin-left: 20%; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 31px;
  position: absolute;
  left: 0;
  bottom: 0;
}
.bot-btn-cel {
  text-align: center;
  font-size: 16px;
  color: rgb(75, 119, 175);
  /* border: 1px solid #9a9b9e; */
  padding: 20px 31px;
  border-radius: 31px;
}
.bot-btn-sure {
  text-align: center;
  font-size: 16px;
  color: #2a7bc2;
  border: 1px solid #2a7bc2;
  padding: 5px 10px;
  border-radius: 31px;
}
.sure-btn {
  position: fixed;
  left: 0;
  bottom: 10px;
  height: 49px;
  background: rgba(75, 119, 175, 1);
  border-radius: 30px;
  font-size: 18px;
  color: #fff;
  width: 90%;
  margin-left: 5%;
  line-height: 49px;
  text-align: center;
}
.lqflq {
  background: #e46e71;
  color: #fff;
  font-size: 12px;
  border-radius: 30px;
  padding: 5px 9px;
}
.lqflq1 {
  border: 1px solid#E46E71;
  color: #e46e71;
  font-size: 12px;
  border-radius: 30px;
  padding: 5px 9px;
}
.fircr {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottomcantent-one-box {
  width: 94%;
  margin-left: 3%;
  display: flex;
  align-items: center;
  border-top: 1px solid #f2f2f2;
  /* margin-top: 15px; */
  height: 40px;
  justify-content: space-between;
}
.van-popup {
  background: none !important;
}
.pup-title {
  color: #fff;
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
}
.close-box {
  text-align: center;
}
.close-box img {
  width: 26px;
  height: 26px;
  margin-top: 30px;
}
input {
  padding: 0;
}
textarea {
  padding: 0;
}
.box {
  height: 100vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.bar {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box-item:last-child {
  border-bottom: none;
}
.share-url {
  width: 92%;
  margin-left: 4%;
  height: 49px;
  background: linear-gradient( 103deg, #FE9E3C 0%, #FF8424 100%);
  line-height: 49px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  border-radius: 5px;
  /* position: fixed; */
  margin-bottom: 20px;
  /* bottom: 55px; */
  left: 0;
  cursor: pointer;
}
.share-url1 {
  width: 92%;
  margin-left: 4%;
  height: 49px;
  /* background: #4873C0; */
  line-height: 49px;
  text-align: center;
  color: #4b77af;
  font-size: 18px;
  border-radius: 5px;
  position: fixed;
  bottom: 45px;
  left: 0;
  cursor: pointer;
}
.lsxq-list-box {
  overflow: scroll;
}
/* @font-face {
    font-style: normal;
    font-family: "PingFang";
    src: url("../../utils/font/PingFang.ttf") format("truetype");
} */
.content-box {
  width: 92%;
  /* margin-left: 4%; */
  border-radius: 10px;
  /* margin-top: 9px; */
  background: #fff;
  /* font-family: "PingFang"; */
  /* height: 100%; */
}
.content-box1 {
  width: 100%;
  /* margin-top: 9px; */
  /* background: #fff; */
  /* font-family: "PingFang"; */
  /* height: 100%; */
  position: absolute;
  top: 54px;
  left: 0;
}
.box-item {
  /* height: 77px; */
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 1px solid #f2f2f2; */
}
.box-item3 {
  width: 92%;
  margin-left: 4%;
  display: flex;
  /* padding: 15px 0; */
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 1px solid #f2f2f2; */
}
.box-item > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
}
.box-item > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: space-between; */
  border-bottom: none;
}
.box-item1 {
  /* height: 92px; */
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 1px solid #f2f2f2; */
}
.box-item1 > div:nth-child(1) {
  font-size: 14px;
  color: #4b4d4d;
}
.box-item1 > div:nth-child(2) {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  /* margin-top: 13px; */
}
.btm-icon {
  width: 12px;
}
.title {
  font-size: 16px;
  color: #c0c0c0;
  margin-top: 8px;
}
.user-type {
  width: 48%;
  display: flex;
  align-items: center;
  text-align: center;
  line-height: 44px;
  cursor: pointer;
  /* margin-right: 15px; */
  margin-top: 14px;
  border-radius: 8px;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  text-align: center;
  font-style: normal;
}
.redbtn-icon {
  width: 18px;
  margin-right: 8px;
}
.input-gh {
  width: 50%;
  border: none;
  /* margin-top: 8px; */
  font-size: 15px;
  font-weight: 500;
}
input::placeholder {
  color: #c0c0c0;
  font-size: 15px;
}
.list-item {
  margin-bottom: 10px;
}
.leftbtn {
  display: flex;
  align-items: center;
}
.gzxqd {
  height: 27px;
  border: 1px solid #4873c0;
  color: #4873c0;
  line-height: 27px;
  font-size: 12px;
  text-align: center;
  padding: 0 10px;
  border-radius: 26px;
  cursor: pointer;
}
.load-more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
}
.share {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 334px;
  height: 447px;
}
.code {
  position: absolute;
  width: 232px;
  top: 140px;
}
.code1 {
  position: absolute;
  width: 50px;
  top: 230px;
  border: 3px solid #4b77ae;
  border-radius: 10px;
}
.subtitle {
  position: absolute;
  font-size: 16px;
  font-weight: 500;
  color: #9a9e9e;
  top: 95px;
  z-index: 1;
}
.list-box {
  /* height: 88px; */
  width: 92%;
  margin-left: 4%;
  margin-bottom: 10px;
  padding-top: 29px;
}
.item-box {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* margin-top: 15px; */
}
.item-box-left {
  width: 25%;
  height: 88px;
  position: relative;
  background: #ffe7e8;
  /* border-right: 2px solid #FFDBDC; */
  border-top: 2px solid #ffe7e8;
  border-left: 2px solid #ffe7e8;
  border-bottom: 2px solid #ffe7e8;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: #e46e71;
  /* background: radial-gradient(circle at right top, transparent 10px,  #FFE7E8 0) top left / 100% 50% no-repeat,
      radial-gradient(circle at right bottom, transparent 10px,  #FFE7E8 0) bottom left /100% 50% no-repeat,
      radial-gradient(circle at left top, transparent 10px, #FAFAFA 0) top right /190px 51% no-repeat,
      radial-gradient(circle at left bottom, transparent 10px, #FAFAFA 0) bottom right /190px 51% no-repeat; */
}
/* .item-box-left::before {
    content: '';
    height: 68px;
    border: 1px dashed #000;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  } */
.item-box-right {
  width: 75%;
  height: 88px;
  position: relative;
  background: #fff;
  border-right: 2px solid #ffe7e8;
  border-top: 2px solid #ffe7e8;
  border-bottom: 2px solid #ffe7e8;
}
.go-use {
  width: 52px;
  height: 22px;
  line-height: 22px;
  background: #e46e71;
  border-radius: 12px;
  font-size: 11px;
  color: #fff;
  text-align: center;
}
.go-use1 {
  width: 52px;
  height: 22px;
  line-height: 22px;
  background: #c0c0c0;
  border-radius: 12px;
  font-size: 11px;
  color: #fff;
  text-align: center;
}
.right-top-box {
  width: 90%;
  margin-left: 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.right-bottom-box {
  width: 90%;
  margin-left: 5%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 7px;
}
.yunqiu-box {
  position: absolute;
  top: -5px;
  left: 22%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 20px;
  height: 20px;
}
.yunqiu-box1 {
  position: absolute;
  bottom: -5px;
  left: 22%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 20px;
  height: 20px;
}
.yunqiu-box div:nth-child(1) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 10px;
  height: 10px;
  background: #fff;
  /* border-radius: 50%; */
  border-radius: 0px 0px 0px 10px;
  border-bottom: 2px solid #ffe7e8;
  border-left: 2px solid #ffe7e8;
}
.yunqiu-box div:nth-child(2) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 10px;
  height: 10px;
  background: #fff;
  border-radius: 50%;
  border-radius: 0px 0px 10px 0px;
  border-bottom: 2px solid #ffe7e8;
  border-right: 2px solid #ffe7e8;
}
.yunqiu-box1 div:nth-child(1) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 10px;
  height: 10px;
  background: #fff;
  border-radius: 10px 0px 0px 0px;
  border-left: 2px solid #ffe7e8;
  border-top: 2px solid #ffe7e8;
}
.yunqiu-box1 div:nth-child(2) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  width: 10px;
  height: 10px;
  background: #fff;
  border-radius: 0px 10px 0px 0px;
  border-top: 2px solid #ffe7e8;
  border-right: 2px solid #ffe7e8;
}
.line {
  width: 1px;
  border: 1px dashed #ffdbdc;
  height: 68px;
}
.box-item4 {
  /* height: 121px; */
  width: 92%;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* border-bottom: 2px solid #f2f2f2; */
  background: rgba(236, 165, 48, 0.16);
  padding: 10px;
  border-radius: 5px;
  color: #eca530;
  margin-top: 15px;
}
</style>
